/* tslint:disable */
/* eslint-disable */
/**
 * Kiwi Framework
 * Kiwi API description
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ClassUpdateMetadataRequest
 */
export interface ClassUpdateMetadataRequest {
    /**
     * ID of the class to update
     * @type {string}
     * @memberof ClassUpdateMetadataRequest
     */
    classId: string;
    /**
     * Updated class details including name, description, and system prompts
     * @type {object}
     * @memberof ClassUpdateMetadataRequest
     */
    classDetails: object;
}

/**
 * Check if a given object implements the ClassUpdateMetadataRequest interface.
 */
export function instanceOfClassUpdateMetadataRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "classId" in value;
    isInstance = isInstance && "classDetails" in value;

    return isInstance;
}

export function ClassUpdateMetadataRequestFromJSON(json: any): ClassUpdateMetadataRequest {
    return ClassUpdateMetadataRequestFromJSONTyped(json, false);
}

export function ClassUpdateMetadataRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClassUpdateMetadataRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'classId': json['classId'],
        'classDetails': json['classDetails'],
    };
}

export function ClassUpdateMetadataRequestToJSON(value?: ClassUpdateMetadataRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'classId': value.classId,
        'classDetails': value.classDetails,
    };
}

